import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import './pixelRuntime'

const GtmNoscript: React.FC<{ gtmPixelId: string }> = ({ gtmPixelId }) => (
    <noscript
        dangerouslySetInnerHTML={{
            __html: `<iframe src=${`"https://www.googletagmanager.com/ns.html?id=${gtmPixelId}"`} height="0" width="0" style="display: none; visibility: hidden;"></iframe>`,
        }}
    />
)

// Ready signal comes from inside the snippet (via __sfMarkVendorReady, installed
// by pixelRuntime), not from <Script onReady>. Next.js fires onReady before an
// inline body executes, which would drain the queue while window.dataLayer is
// still undefined.
export const GTMPixel: React.FC<{
    landingPage: ApiShopperLandingPage
    scriptsReady?: boolean
}> = ({ landingPage, scriptsReady = true }) => {
    const gtmPixelId = landingPage.integrations.gtmPixelId
    if (!gtmPixelId || !scriptsReady) return null

    return (
        <>
            <Script id="google-tag-manager" strategy="afterInteractive">
                {`
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','${gtmPixelId}');
                        window.__sfMarkVendorReady && window.__sfMarkVendorReady('gtm');
                    `}
            </Script>
            <GtmNoscript gtmPixelId={gtmPixelId} />
        </>
    )
}
